import { isDef } from "@/CommonDP/utils/common";
import globalParams from "@/CommonDP/utils/globalParams";
import asyncCom from '@/CommonDP/commons/asyncCom';
/**
  * @typedef  { 'User'|'SystemRole'|'SpecRole'|'PrjRole'|'Label'|'Dept' }  MemberType
  * @typedef  { {id:string,nodeId:String, name: string, selectName: string, selectCode: MemberType }}  BaseMemberItem
  *  **/
export const ALL_NAV_LIST = [
  { label: "人员", name: "1", code: "User", array: [] },
  { label: "系统角色", name: "2", code: "SystemRole", array: [] },
  { label: "项目角色", name: "3", code: "SpecRole", array: [] },
  // { label: "项目角色", name: "4", code: "PrjRole", array: [] },
  // { label: "标签", name: "5", code: "Label", array: [] },
  // { label: "部门", name: "6", code: "Dept", array: [] }
];
export const CODE_ID_MAP = {
  User: { id: 'nodeId', name: 'nodeName', label: "人员" },
  SystemRole: { id: 'roleID', name: 'roleName', label: "系统角色" },
  SpecRole: { id: 'roleId', name: 'roleName', label: "专业角色" },
  PrjRole: { id: 'roleID', name: 'roleName', label: "项目角色" },
  Label: { id: 'tagId', name: 'tagName', label: "标签" },
  Dept: { id: 'deptId', name: 'deptName', label: "部门" }
};
/**
  * @description 打开选择人员弹窗
  * @param {object} props 传递给弹窗的props
  * @param {boolean} props.filterOneself 是否过滤当前用户 ,默认为false
  * @param {number} props.max? 限制人数，可多选单选人员
  * @param {MemberType[]} props.codePri 权限列表： ALL_NAV_LIST 中code组成的数组
  * @param {BaseMemberItem[]} props.usersList 人员信息的数组列表：userSelected抛出去的数组
  * @param {string} props.userIds 人员列表 用户id字符串,仅支持userId,使用,隔开
  ******
  * @param {string} props.curDeptId 当前部门
  * @param {string} props.deptId 部门id
  * @param {string} props.prjId 项目id
  * @param {string} props.prjRoleId 项目角色id
  * @param {string} props.specRoleId 专业角色id
  * @param {string} props.sysRoleId 系统角色id
  * @param {string} props.labelRole 标签 ///暂时还没用
  * @returns {Promise<BaseMemberItem[]>}
 */
export async function openMember(props) {
  const chooseMember_custom = globalParams.get("custom.chooseMember");
  if (isDef(chooseMember_custom)) {
    return await chooseMember_custom(props);
  }
  // if (!props.codePri) {
  //   return Promise.reject("codePri is required");
  // }
  // return await openChooseMember(props);
  const component = (await import('@/CommonDP/components/chooseMember/index.vue')).default;
  return await asyncCom(component, {}, props);
}
// 同openMember的props参数
export async function openH5Member(props) {
  const component = (await import('@/CommonDP/components/chooseMember/indexH5.vue')).default;
  return await asyncCom(component, {}, props);
}

// export const openChooseMember = async (props) => {
//   const component = (await import('./index.vue')).default;
//   return await asyncCom(component, {}, props);
// };

// 根据name 来判断对应的组件
export function typeCompontent(name) {
  const comDescribe = {
    "User": () => import("@/CommonDP/components/chooseMember/component/User.vue"),
    "SystemRole": () => import("@/CommonDP/components/chooseMember/component/SystemRole.vue"),
    "SpecRole": () => import("@/CommonDP/components/chooseMember/component/SpecRole.vue"),
    "PrjRole": () => import("@/CommonDP/components/chooseMember/component/PrjRole.vue"),
    "Label": () => import("@/CommonDP/components/chooseMember/component/Label.vue"),
    "Dept": () => import("@/CommonDP/components/chooseMember/component/Dept.vue")
  };
  return comDescribe[name];
}

// 展示ALL_NAV_LIST中code组成的数组
export function periNavList(array) {
  return ALL_NAV_LIST.filter(e => array.includes(e.code));
}
